var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Renderer2, ElementRef, Input, ChangeDetectionStrategy, HostBinding, Optional, ContentChildren, QueryList, forwardRef, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { LyRipple } from 'alyle-ui/ripple-minimal';
import { LyTheme, Platform, IsBoolean, LyBg, LyColor } from 'alyle-ui/core';
import { LyIconButton } from 'alyle-ui/icon-button';
import { LyShadowService } from 'alyle-ui/shadow';
import { DomSanitizer } from '@angular/platform-browser';
// @Directive({ selector: '[ly-button][raised]' })
// export class LyButtonRaised {
//   private _raised = true;
//   constructor() { }
// }
var LyButton = /** @class */ (function () {
    function LyButton(elementRef, renderer, sanitizer, shadowService, theme, lyColor, lyBg) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.sanitizer = sanitizer;
        this.shadowService = shadowService;
        this.theme = theme;
        this.lyColor = lyColor;
        this.lyBg = lyBg;
        this._disabled = false;
        this._prevFocused = true;
        this.html = '';
        this.size = 10;
        this.stateH = true;
        this._color = 'colorText';
        this._deep = false;
        this._bg = 'rgba(0, 0, 0, 0)';
        this.colorString = null;
        this.bgString = null;
        this._raised = false;
        this._rippleSensitive = false;
        this.buttonPadding = new BehaviorSubject('');
        this.span = true;
        this.nativeElement = this.elementRef.nativeElement;
    }
    Object.defineProperty(LyButton.prototype, "rippleSensitive", {
        get: function () {
            return this._rippleSensitive;
        },
        set: function (value) {
            if (value === false) {
                this._rippleSensitive = false;
            }
            else {
                this._rippleSensitive = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    LyButton.prototype.ngOnInit = function () { };
    LyButton.prototype.ngOnChanges = function (changes) {
        if (this.raised || this.raisedColorInverted) {
            var colorRaised = this.bg || this.color || '';
            if (this.raisedColorInverted) {
                colorRaised = this.color;
            }
            this._lastClass = this.shadowService.setShadow(this.elementRef, this.renderer, ['3', colorRaised], this._lastClass);
        }
        else if (this._lastClass) {
            /** reset */
            this.renderer.removeClass(this.elementRef.nativeElement, this._lastClass);
            this._lastClass = null;
        }
    };
    LyButton.prototype.ngOnDestroy = function () { };
    LyButton.prototype.focused = function () {
        this.elementRef.nativeElement.focus();
    };
    Object.defineProperty(LyButton.prototype, "btnWidth", {
        get: function () {
            return this.elementRef.nativeElement.offsetWidth;
        },
        enumerable: true,
        configurable: true
    });
    LyButton.prototype.ngAfterViewInit = function () {
        var _this = this;
        var el = this.elementRef.nativeElement;
        if (Platform.isBrowser) {
            this.ripple.setTriggerElement(el);
            Promise.resolve(null).then(function () {
                if (_this.iconButton.length !== 0) {
                    var left_1;
                    var right_1;
                    _this.iconButton.forEach(function (iconButton) {
                        var ele = iconButton.elementRef.nativeElement;
                        var eve = ele;
                        while (eve = eve.previousSibling) {
                            if (eve.nodeName === '#text' && eve.nodeValue.trim() !== '') {
                                left_1 = 'ly-button-padding-left';
                            }
                        }
                        eve = ele;
                        while (eve = eve.nextSibling) {
                            if (eve.nodeName === '#text' && eve.nodeValue.trim() !== '') {
                                right_1 = 'ly-button-padding-right';
                            }
                            // this.buttonPadding.next(`${right}`);
                            // this.buttonPadding.next(`${right}`);
                        }
                    });
                    setTimeout(function () {
                        right_1 === right_1 && _this.iconButton.length === 2 ? _this.buttonPadding.next("") : _this.buttonPadding.next((right_1 || '') + " " + (left_1 || ''));
                    });
                }
                else {
                    _this.buttonPadding.next('ly-button-padding');
                }
            });
        }
    };
    Object.defineProperty(LyButton.prototype, "btnHeight", {
        get: function () {
            return this.elementRef.nativeElement.offsetHeight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyButton.prototype, "deep", {
        get: function () {
            return this._deep;
        },
        set: function (val) {
            this._deep = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LyButton.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        set: function (val) {
            this._disabled = val;
            if (val) {
                this.elementRef.nativeElement.setAttribute('disabled', 'true');
            }
            else {
                this.elementRef.nativeElement.removeAttribute('disabled');
            }
        },
        enumerable: true,
        configurable: true
    });
    LyButton.prototype._hasButton = function () {
        return !!this.disabled || !!this.deep || !!this.bg || !!this.color;
    };
    LyButton.prototype.sanitizerStyle = function (val) {
        return this.sanitizer.bypassSecurityTrustStyle(val);
    };
    LyButton.decorators = [
        { type: Component, args: [{
                    selector: '[ly-button], ly-button',
                    styles: [":host { z-index: 1; padding: 0; justify-content: center; -webkit-tap-highlight-color: transparent; line-height: 36px; white-space: nowrap; transform: scale3d(1, 1, 1); } @media not all and (hover: none) { :host:after { content: ''; top: 0; left: 0; right: 0; bottom: 0; position: absolute; background: currentColor; opacity: 0; border-radius: inherit; pointer-events: none; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1); } :host:hover:after { opacity: .11; } } .ly-button-ripple { position: absolute; top: 0; bottom: 0; left: 0; right: 0; display: block; width: 100%; height: 100%; z-index: 2; transform: scale3d(1, 1, 1); border-radius: inherit; overflow: hidden; pointer-events: none; } .ly-button-hover { pointer-events: none; position: absolute; top: 0; bottom: 0; left: 0; right: 0; border-radius: inherit; opacity: 0; background: currentColor; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1); } :host /deep/ [ly-icon-button] { z-index: 5 !important; } :host /deep/ [ly-icon-button] { color: currentColor !important; } .ly-button-content { text-align: inherit; height: 100%; justify-content: inherit; align-items: center; width: 100%; display: flex; position: relative; box-sizing: border-box; line-height: inherit; white-space: inherit; } .ly-button-padding { padding: 0 16px; } .ly-button-padding-left { padding-left: 16px; } .ly-button-padding-right { padding-right: 16px; } :host.ly-button-init { transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1) 0ms !important; } :host._disabled { pointer-events: none !important; background: rgba(0, 0, 0, 0.14) !important; color: rgba(0, 0, 0, 0.48) !important; box-shadow: none !important; } :host /deep/ [type=\"file\"] { position: absolute; top: 0; bottom: 0; left: 0; right: 0; opacity: 0; display: none; } :host:-moz-focusring::-moz-focus-inner { border-color: transparent; } :host { background: transparent; color: currentColor; border: none !important; -moz-appearance: none; min-height: 36px; height: 36px; margin: 0; border-radius: 4px; outline: none !important; font-size: 14px; font-weight: 500; min-width: 88px; box-sizing: border-box; position: relative; text-align: center; cursor: pointer; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; display: inline-block; transition: all 375ms cubic-bezier(0.23, 1, 0.32, 1) 0ms; } /deep/ { /* button raised */ } /deep/ [ly-button~=\"disabled\"] { pointer-events: none; background: transparent; color: #000; opacity: .26; } /deep/ [ly-n], /deep/ [ly-w], /deep/ [ly-c] { overflow: hidden; } /deep/ [ly-c] { z-index: 4; border-radius: inherit; pointer-events: none; } /deep/ [ly-c] div { transition: all 0.7s ease-out; transition-property: opacity, -webkit-transform; transition-property: transform, opacity; transition-property: transform, opacity, -webkit-transform; /*-webkit-transform: scale(0); transform: scale(0);*/ pointer-events: none; position: relative; cursor: pointer; display: inline-block; overflow: hidden; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; -webkit-tap-highlight-color: transparent; will-change: opacity, transform; opacity: 1; box-sizing: border-box; } /deep/ [ly-n] { position: relative !important; padding: 0 16px; height: 100%; width: 100%; box-sizing: border-box; display: inline-flex; cursor: pointer; pointer-events: none; } /deep/ [ly-n], /deep/ [ly-w], /deep/ [ly-c], /deep/ [ly-c] { position: absolute; top: 0; bottom: 0; left: 0; right: 0; overflow: hidden; /*transition: cubic-bezier(0.25, 0.46, 0.45, 0.94) 975ms*/ } /deep/ [ly-button~=\"raised\"]:active { box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 11px, rgba(0, 0, 0, 0.123) 0px 3px 11px !important; } /deep/ [ly-button~=\"raised\"]:focus { box-shadow: rgba(0, 0, 0, 0.12) 0px 3px 11px, rgba(0, 0, 0, 0.123) 0px 3px 11px !important; } /deep/ [ly-button~=\"raised\"]:not([ly-button~=\"disabled\"]) { box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 6px, rgba(0, 0, 0, 0.123) 0px 2px 4px; } :host /deep/ .btn_cont { display: block; line-height: inherit; height: inherit; align-content: space-around; text-align: center; align-self: center; alignment-baseline: middle; align-items: center; text-align: inherit; white-space: nowrap; width: inherit; text-overflow: ellipsis; overflow: hidden; } :host /deep/ [ly-w] { pointer-events: none; } :host /deep/ .rippleEffect { -webkit-transform: scale(0); -moz-transform: scale(0); transform: scale(0); -ms-transform: scale(0); -os-transform: scale(0); opacity: .18; } "],
                    // tslint:disable-next-line:use-host-property-decorator
                    host: {
                        '[class._disabled]': '_disabled',
                        '[class.ly-button-init]': '_hasButton()'
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: "\n  <div class=\"ly-button-ripple\" lyRipple [lyRippleSensitive]=\"rippleSensitive\"></div>\n  <div class=\"ly-button-content\" [style.font-family]=\"(theme.typography | async)?.fontFamily\" [ngClass]=\"buttonPadding | async\">\n    <ng-content></ng-content>\n  </div>\n  ",
                    preserveWhitespaces: false
                },] },
    ];
    /** @nocollapse */
    LyButton.ctorParameters = function () { return [
        { type: ElementRef, },
        { type: Renderer2, },
        { type: DomSanitizer, },
        { type: LyShadowService, },
        { type: LyTheme, },
        { type: LyColor, decorators: [{ type: Optional },] },
        { type: LyBg, decorators: [{ type: Optional },] },
    ]; };
    LyButton.propDecorators = {
        "boxShadow": [{ type: HostBinding, args: ['style.box-shadow',] },],
        "rippleSensitive": [{ type: Input, args: ['sensitive',] },],
        "color": [{ type: Input },],
        "bg": [{ type: Input },],
        "raised": [{ type: Input },],
        "raisedColorInverted": [{ type: Input },],
        "styleBackground": [{ type: HostBinding, args: ['style.background',] },],
        "styleColor": [{ type: HostBinding, args: ['style.color',] },],
        "ripple": [{ type: ViewChild, args: [LyRipple,] },],
        "iconButton": [{ type: ContentChildren, args: [forwardRef(function () { return LyIconButton; }),] },],
        "deep": [{ type: Input },],
        "disabled": [{ type: Input },],
    };
    __decorate([
        IsBoolean(),
        __metadata("design:type", Boolean)
    ], LyButton.prototype, "raised", void 0);
    __decorate([
        IsBoolean(),
        __metadata("design:type", String)
    ], LyButton.prototype, "raisedColorInverted", void 0);
    return LyButton;
}());
export { LyButton };
//# sourceMappingURL=button.js.map